const mutationsContext = require.context('./', true, /^(?!.*index).*\.js$/);


export default (entities) => mutationsContext.keys().reduce((memo, key) => {
  const mutationsFile = mutationsContext(key).default;
  return { ...memo, ...mutationsFile(entities) };
}, {});
